module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-science-icon-ecb7177675023d7c24025c3814125dbf.svg";